"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monticelli-d-ongina": {
    "5b11c11e": [{
      "hkey": "4e001156",
      "slug": "monticelli-d-ongina",
      "name": "Monticelli d'Ongina",
      "primary": true,
      "skipSearch": false
    }],
    "borgonovo": [{
      "hkey": "4e001156",
      "slug": "monticelli-d-ongina",
      "name": "Monticelli d'Ongina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4ec8064": [{
      "hkey": "4a324e7b",
      "slug": "olza-fogarole",
      "name": "Olza-Fogarole",
      "primary": true,
      "skipSearch": false
    }],
    "fogarole": [{
      "hkey": "4a324e7b",
      "slug": "olza-fogarole",
      "name": "Olza-Fogarole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "967ca6e4": [{
      "hkey": "4a324e7b",
      "slug": "olza-fogarole",
      "name": "Olza-Fogarole",
      "primary": true,
      "skipSearch": false
    }],
    "olza": [{
      "hkey": "4a324e7b",
      "slug": "olza-fogarole",
      "name": "Olza-Fogarole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monticelli-d-ongina"
    }]
  }
};
exports["default"] = _default;